import { ReactNode } from 'react';
import { Popover } from '../../../../../../../common/components/Popover/Popover';
import { Help } from '../../../../../../../common/components/icons/Help';
import { useMobile } from '../../../../../../../common/services/screenSize/ScreenSizeService';
import { TagLike } from '../../../../../../../common/util/TagLike';
import { DetailView, Label, Icon, Value, IconCircle, HelpIconWrapper } from './Detail.styles';

interface Props {
  children?: ReactNode;
  label: string;
  icon: TagLike<'svg'>;
  notProvided?: boolean;
  toolTip?: string;
}

export const Detail = ({ children, label, icon, notProvided = false, toolTip }: Props) => {
  const mobile = useMobile();

  if (notProvided) {
    return null;
  }

  return (
    <DetailView>
      <IconCircle>
        <Icon as={icon} aria-label={label} />
      </IconCircle>

      {!mobile && <Label>{label}</Label>}

      <Value>{children}</Value>

      {toolTip && (
        <HelpIconWrapper>
          <Popover content={toolTip}>
            <Help />
          </Popover>
        </HelpIconWrapper>
      )}
    </DetailView>
  );
};
